<script setup lang="ts">
interface Props {
  textAlign?: 'center' | 'left'
}
withDefaults(defineProps<Props>(), {
  textAlign: 'center',
})
const { stats } = storeToRefs(useStatsStore())
</script>

<template>
  <div class="flex-col">
    <div
      class="flex items-center font-semibold text-base justify-center"
      :class="{ 'sm:justify-start': textAlign === 'left' }"
    >
      <YscRating
        :model-value="stats.average"
        class="text-orange-400 mr-3"
        small
      />
      <span>{{ stats.average }} / 5</span>
    </div>
    <i18n-t
      keypath="components.app_rating_trusted_shop.description_note.description_dynamic"
      tag="p"
      scope="global"
      class="text-sm text-center"
      :class="{ 'sm:text-left': textAlign === 'left' }"
    >
      <template #emphasis_string>
        <strong>{{ $t('components.app_rating_trusted_shop.description_note.description_emphasis') }}</strong>
      </template>
    </i18n-t>
    <p
      class="text-sm text-center"
      :class="{ 'sm:text-left': textAlign === 'left' }"
    >
      {{ $t('components.app_rating_trusted_shop.total_review_dynamic', {
        count_number: stats.count,
      }) }}
    </p>
  </div>
</template>
